<template>
  <div class="container containerForm">
    <h2 style="text-align: center">إضافة مستخدم جديد</h2>
    <form>
      <div class="form-group">
        <label for="firstName">الاسم الأول</label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          v-model="userData.firstName"
        />
      </div>
      <div class="form-group">
        <label for="lastName">الاسم الأخير</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          v-model="userData.lastName"
        />
      </div>
      <div class="form-group">
        <label for="email">البريد الإلكتروني</label>
        <input
          type="text"
          class="form-control"
          id="email"
          v-model="userData.email"
        />
      </div>
      <div class="form-group">
        <label for="role">الدور</label>
        <select class="form-control" id="role" v-model="userData.role">
          <option value="" disabled selected>اختر الدور</option>
          <option value="ادمن">ادمن</option>
          <option value="موظف">موظف</option>
        </select>
      </div>
      <div class="form-group">
        <label for="phoneNumber">رقم الهاتف </label>
        <input
          type="text"
          class="form-control"
          id="phoneNumber"
          v-model="userData.phoneNumber"
        />
      </div>
      <div class="form-group">
        <label for="password">كلمة المرور</label>
        <input
          type="password"
          class="form-control"
          id="password"
          v-model="userData.password"
        />
      </div>
      <button type="submit" class="btn btn-primary" @click.prevent="AddUser">
        حفظ
      </button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      userData: {
        firstName: "",
        lastName: "",
        email: "",
        role: "",
        phoneNumber: "",
        password: "",
      },
    };
  },
  methods: {
    stringifyProperties(obj) {
      const newObj = {};
      for (const key in obj) {
        if (key !== "password" && key !== "email") {
          newObj[key] = String(obj[key]);
        } else {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    },
    AddUser() {
      for (const key in this.userData) {
        if (!this.userData[key]) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء ملء جميع الحقول المطلوبة",
            position: "bottomRight",
          });
          return;
        }
      };

      const userDataToSend = this.stringifyProperties(this.userData);
      // console.log(userDataToSend);
      Axios
        .post("/users", userDataToSend)
        .then((response) => {
          // Reset form fields after successful submission
          this.userData = {
            firstName: "",
            lastName: "",
            email: "",
            role: "",
            phoneNumber: "",
            password: "",
          };
          this.$iziToast.success({
            timeout: 2000,
            message: "تم إضافة المستخدم بنجاح",
            position: "bottomRight",
          });
          this.$router.push("/admin/users");
        })
        .catch((error) => {
          // console.log(error.response.data.errors);
          if (
            error.response &&
            error.response.data
          ) {
            const errorMessage = error.response.data.errors;
            this.$iziToast.error({
              timeout: 5000,
              message: errorMessage,
              position: "bottomRight",
            });
          } else {
            this.$iziToast.error({
              timeout: 2000,
              message: "فشل الإضافة",
              position: "bottomRight",
            });
          }
        });
    },
  },
};
</script>
